<template>
    <div class="">
        <slot
            :msgError="msgError"
            :msgSuccess="msgSuccess"
            :loading="loading"
            :disableSubmit="disableSubmit"
            :isError="isError"
            :isInvalid="isInvalid"
            :response="response"
            :msg="msg"
            :notReload="notReload"
            :redirectTo="redirectTo"
            :customData="customData"
            :setCustomData="setCustomData"
            :getError="getErrorByField"
            :submit="isParentForm ? submitMultiple : submit"
            :submitMultiple="submitMultiple"
        >
            <component :is="formTag" action="#" ref="form"> </component>
        </slot>
    </div>
</template>

<script>
import axios from "axios";

import mixinCommon from "./mixinCommon.vue";
import mixinPubSub from "./mixinPubSub.vue";

export default {
    mixins: [mixinCommon, mixinPubSub],
    props: {
        defaultFormTag: {
            type: String,
            default: "form",
        },

        disableForm: {
            type: [String, Number, Boolean],
            default: false,
        },

        isParentForm: {
            type: [String, Number, Boolean],
            default: false,
        },
        isChildForm: {
            type: [String, Number, Boolean],
            default: false,
        },

        ////
        defaultMsgSuccess: {
            type: String,
            default: "Dati inviati",
        },
        defaultMsgError: {
            type: String,
            default: "Errore nella comunicazione col server",
        },
        defaultDisableSummit: {
            type: [Boolean, Number, String],
            default: false,
        },
        ////

        ////
        notReload: {
            type: [Boolean, Number, String],
            default: false,
        },
        defaultRedirectTo: {
            type: [Boolean, Number, String],
            default: null,
        },
        defaultReloadDelay: {
            type: [Number, String],
            default: 0,
        },
        ////

        validateBeforeSend: {
            type: [Boolean, Number, String],
            default: false,
        },
        notifyOnSuccess: {
            type: [Boolean, Number, String],
            default: false,
        },
        successNotifyDelay: {
            type: [Number, String],
            default: 1200,
        },
    },
    provide() {
        return {
            formAjax: this,
        };
    },
    data() {
        return {
            data: {},

            formData: {},
            msgSuccess: this.defaultMsgSuccess,
            msgError: this.defaultMsgError,

            msg: "",

            loading: false,

            disableSubmit: this.defaultDisableSummit,

            isError: 0,

            response: null,

            //notReload: this.defaultNotReload,
            redirectTo: this.defaultRedirectTo,

            reloadDelay: this.defaultReloadDelay,

            disableRootLoading: false,

            files: null,

            isInvalid: false,

            customData: null,

            formTag: this.defaultFormTag,

            registeredInputs: [], // Registry for child inputs
        };
    },
    mounted() {},
    watch: {
        loading: function (loading) {
            this.triggerPageLoading(loading);

            if (this.response && this.response.status) {
                return;
            }

            this.disableSubmit = loading;
        },
    },
    methods: {
        getNormalizedDelay(value, fallback = 0) {
            const parsed = Number(value);
            return Number.isFinite(parsed) && parsed >= 0 ? parsed : fallback;
        },
        registerInput(inputComponent) {
            if (!this.registeredInputs.includes(inputComponent)) {
                this.registeredInputs.push(inputComponent);
            }
        },
        unregisterInput(inputComponent) {
            const index = this.registeredInputs.indexOf(inputComponent);
            if (index > -1) {
                this.registeredInputs.splice(index, 1);
            }
        },
        getErrorByField(fields) {
            return (Array.isArray(fields) ? fields : [fields])
                .map((fieldName) => {
                    try {
                        return this.response.errors[fieldName][0] || "";
                    } catch (e) {
                        return "";
                    }
                })
                .filter((errorMsg) => errorMsg)
                .join("<br>");
        },

        getForm() {
            if (this.$refs.form) {
                return this.$refs.form;
            }

            let form =
                this.$el.tagName === "FORM"
                    ? this.$el
                    : this.$el.querySelector("form");

            if (!form) {
                form = this.$el.hasAttribute("action")
                    ? this.$el
                    : this.$el.querySelector("[action]");
            }

            return form;
        },

        fetchFormData() {
            let formData = {};

            this.formTag = "form";

            let form = this.getForm();

            // Get all named inputs except files (which are handled in fetchFiles)
            const inputs = form.querySelectorAll(
                'input:not([type="file"]), select, textarea'
            );
            const entries = [];

            inputs.forEach((el) => {
                if (!el.name || el.disabled) return;

                if (el.type === "checkbox" || el.type === "radio") {
                    if (el.checked) {
                        entries.push({ name: el.name, value: el.value });
                    }
                } else if (el.tagName === "SELECT" && el.multiple) {
                    Array.from(el.selectedOptions).forEach((opt) => {
                        entries.push({ name: el.name, value: opt.value });
                    });
                } else {
                    entries.push({ name: el.name, value: el.value });
                }
            });

            entries.forEach(({ name, value }) => {
                try {
                    value = JSON.parse(value) || value;
                } catch (e) {}

                let normName = name;
                if (name.indexOf("[]") >= 0) {
                    normName = name.replace("[]", "");
                    if (!formData[normName]) {
                        formData[normName] = [];
                    }
                    formData[normName].push(value);
                } else if (name.search(/\[.+\]/i) >= 0) {
                    normName = name.split("[").shift();

                    if (!formData[normName]) {
                        formData[normName] = {};
                    }

                    let obj = formData[normName];

                    let lastKey = "";

                    const nameList = name.match(/\[[^\[^\]]+\]/gi);
                    nameList.forEach((key, n) => {
                        key = key.replace("[", "").replace("]", "");

                        if (!obj[key] || obj[key] == value) {
                            obj[key] = {};
                        }

                        if (n < nameList.length - 1) {
                            obj = obj[key];
                        } else {
                            lastKey = key;
                        }
                    });

                    obj[lastKey] = value;
                } else {
                    formData[normName] = value;
                }
            });

            this.formTag = this.defaultFormTag;

            if (!formData["referral"]) {
                formData["referral"] = document.location.href;
            }

            for (let name in formData) {
                if (formData[name] instanceof Object) {
                    try {
                        formData[name] = JSON.stringify(formData[name]);
                    } catch (e) {
                        // ignore
                    }
                }
            }

            this.formData = formData;
            return formData;
        },

        reset() {
            this.formData = null;
            this.response = null;

            this.isInvalid = false;
            this.isError = false;

            this.msg = "";
            this.disableSubmit = false;
        },

        addFile(file, name) {
            if (!(file instanceof Blob) && !name) {
                return false;
            }

            if (!this.files) {
                this.files = {};
            }
            if (!this.files[name]) {
                this.files[name] = [];
            }

            this.files[name].push(file);

            return this.files;
        },

        removeFile(name) {
            if (this.files && this.files[name]) {
                this.files[name] = [];
            }
        },

        fetchFiles() {
            const childs = this.registeredInputs || [];
            childs.forEach((child) => {
                if (typeof child.getFilesToSend === "function") {
                    let fieldName = child.name;

                    if (!fieldName && child.$attrs) {
                        fieldName = child.$attrs.name || child.$attrs["name"];
                    }

                    // Strict check to ensure we don't send without a name
                    if (fieldName) {
                        child
                            .getFilesToSend()
                            .forEach((file) => this.addFile(file, fieldName));
                    }
                }
            });

            let files = {};
            if (this.files && Object.keys(this.files).length) {
                for (let name in this.files) {
                    if (!files[name]) {
                        files[name] = [];
                    }
                    this.files[name].forEach((file) => {
                        files[name].push(file);
                    });
                }
            }

            let form = this.getForm();
            let $files = form.querySelectorAll('[type="file"][name]');
            if (!$files.length) {
                return files;
            }

            $files.forEach((el) => {
                let name = el.getAttribute("name");

                if (el.files && el.files.length) {
                    for (let n = 0; n < el.files.length; n++) {
                        let file = el.files[n];
                        if (file instanceof File) {
                            if (!files[name]) {
                                files[name] = [];
                            }
                            files[name].push(file);
                        }
                    }
                }
            });

            return files;
        },

        hasFiles() {
            return Object.keys(this.fetchFiles()).length;
        },

        sendData(formData, callback = () => {}) {
            let _normalizeResp = (resp = {}) => {
                if (typeof resp !== "object") resp = {};
                if (typeof resp.status === "undefined") resp.status = 0;

                let firstValidationError = "";
                if (
                    resp &&
                    resp.errors &&
                    typeof resp.errors === "object" &&
                    !Array.isArray(resp.errors)
                ) {
                    for (const field of Object.keys(resp.errors)) {
                        const fieldErrors = resp.errors[field];
                        if (Array.isArray(fieldErrors) && fieldErrors.length) {
                            firstValidationError = fieldErrors[0];
                            break;
                        }
                    }
                }

                if (!resp.msg && !resp.message) {
                    resp.msg = resp.status ? this.msgSuccess : this.msgError;
                } else if (resp.message) {
                    resp.msg = resp.message;
                }
                if (!resp.status && firstValidationError) {
                    resp.msg = firstValidationError;
                }

                return resp;
            };

            let form = this.getForm();
            let url = form.getAttribute("action");
            let verb = (form.getAttribute("method") || "POST").toUpperCase();

            if (this.validateBeforeSend && !this.validate()) {
                return callback(
                    _normalizeResp({
                        status: 0,
                    })
                );
            }

            if (formData instanceof FormData) {
                let xhr = new XMLHttpRequest();
                xhr.open(verb, url, true);
                xhr.onload = (evt) => {
                    let respData = null;
                    try {
                        if (evt.target.response) {
                            respData =
                                typeof evt.target.response === "object"
                                    ? evt.target.response
                                    : JSON.parse(evt.target.response);
                        }
                    } catch (e) {}

                    if (evt.target.status !== 200) {
                        callback(_normalizeResp(respData || {}));
                    } else {
                        if (respData) {
                            callback(_normalizeResp(respData));
                        } else {
                            callback(_normalizeResp());
                        }
                    }
                };
                xhr.send(formData);
            } else {
                axios({
                    method: verb,
                    url: url,
                    data: formData,
                })
                    .then((response) => {
                        callback(_normalizeResp(response.data));
                    })
                    .catch((error) => {
                        const response = error.response || {};
                        const { data: resp } = response;
                        callback(_normalizeResp(resp));
                    });
            }
        },

        getChildsForm(filterDisabled = true) {
            return (this.registeredInputs || []).filter(
                (child) =>
                    (!filterDisabled || !+child.disableForm) &&
                    !!+child.isChildForm
            );
        },

        async submitMultiple(evt) {
            if (evt && evt.prevendDefault) {
                evt.preventDefault();
            }

            this.loading = true;

            const asyncSubmit = async (formComp) => {
                return new Promise((resolve, reject) => {
                    formComp.$once("response", resolve);
                    formComp.submit();
                });
            };

            const childsForm = this.getChildsForm(true);
            async function* asyncGenerator() {
                for (const formComp of childsForm) {
                    yield await asyncSubmit(formComp);
                }
            }

            for await (const resp of asyncGenerator()) {
                if (!resp || !+resp.status) {
                    this.isError = true;

                    if (resp.msg) {
                        this.msg = resp.msg;
                    }

                    return false;
                }
            }

            const resp = this.disableForm
                ? this.response
                : await (async () => {
                      return new Promise((resolve, reject) => {
                          this.$once("response", resolve);
                          this.submit();
                      });
                  })();

            this.loading = false;

            return resp ? resp.status : false;
        },

        submit(evt) {
            if (evt && evt.prevendDefault) {
                evt.preventDefault();
            }

            const form = this.getForm();
            if (
                form &&
                typeof form.checkValidity === "function" &&
                !form.checkValidity()
            ) {
                if (typeof form.reportValidity === "function") {
                    form.reportValidity();
                }
                return false;
            }

            this.reset();

            let sendMode = "formData";

            let formData = new FormData();

            let filesToSend = this.fetchFiles();
            if (
                !filesToSend ||
                filesToSend.length === 0 ||
                Object.keys(filesToSend).length === 0
            ) {
                formData = {};
            } else {
                for (let name in filesToSend) {
                    filesToSend[name].forEach((file) => {
                        if (formData instanceof FormData) {
                            if (file.name) {
                                formData.append(name, file, file.name);
                            } else {
                                formData.append(name, file);
                            }
                        } else {
                            formData[name] = file;
                        }
                    });
                }
            }

            let dataToSend = this.fetchFormData();

            for (let name in dataToSend) {
                let valueToSend = dataToSend[name];

                if (formData instanceof FormData) {
                    formData.append(name, valueToSend);
                } else {
                    formData[name] = valueToSend;
                }
            }

            this.$emit("request", formData);

            this.loading = true;
            if (this.disableForm) {
                const resp = (this.response = { status: true });

                this.$emit("response", resp);

                this.loading = false;
            } else {
                this.sendData(formData, (resp) => {
                    this.$emit("response", resp);
                    this.response = resp;

                    this.isError = !resp.status;
                    this.msg = resp.msg;
                    const shouldNotifySuccess =
                        !this.isError && !!+this.notifyOnSuccess;
                    const successDelay = this.getNormalizedDelay(
                        this.successNotifyDelay,
                        1200,
                    );
                    const reloadDelay = this.getNormalizedDelay(
                        this.reloadDelay,
                        0,
                    );

                    if (resp.notReload || this.notReload) {
                        this.loading = false;

                        this.notifyBy(this.isError ? "error" : "success", {
                            message: this.msg,
                        });
                    } else if (resp.redirectTo || this.redirectTo) {
                        if (shouldNotifySuccess) {
                            this.notifyBy("success", {
                                message: this.msg,
                            });
                        }

                        setTimeout(() => {
                            document.location.href =
                                resp.redirectTo || this.redirectTo;
                        }, shouldNotifySuccess ? Math.max(reloadDelay, successDelay) : reloadDelay);
                    } else if (!this.isError) {
                        if (shouldNotifySuccess) {
                            this.notifyBy("success", {
                                message: this.msg,
                            });
                        }

                        setTimeout(() => {
                            document.location.reload();
                        }, shouldNotifySuccess ? Math.max(reloadDelay, successDelay) : reloadDelay);
                    } else {
                        this.loading = false;

                        this.notifyBy(this.isError ? "error" : "success", {
                            message: this.msg,
                        });
                    }

                    if (resp.status) {
                        this.disableSubmit = true;
                    }
                });
            }
        },

        validate() {
            let isInvalid = false;

            (this.registeredInputs || []).forEach((child) => {
                if (typeof child.checkIsValid === "function") {
                    if (!child.checkIsValid()) {
                        isInvalid = true;
                    }
                }
            });

            this.isInvalid = isInvalid;

            return !isInvalid;
        },
    },
};
</script>
